<template>
  <div class="user-info-container">
    <el-card class="user-info-card">
      <h2 class="user-info-title">会员信息</h2>
      <el-row v-if="loading" justify="center" style="margin: 32px 0;">
        <el-spinner />
      </el-row>
      <el-row v-else>
        <el-col :span="24">
          <el-alert v-if="error" :title="error" type="error" show-icon :closable="false" style="margin-bottom:16px" />
          <el-descriptions :column="1" border>
            <el-descriptions-item label="用户名">{{ info.username }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ info.email || '-' }}</el-descriptions-item>
            <el-descriptions-item label="角色">{{ info.role === 'admin' ? '管理员' : '普通用户' }}</el-descriptions-item>
            <el-descriptions-item label="VIP类型">
              <span :class="['vip-badge', info.vip_type]">{{ vipTypeText(info.vip_type) }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="VIP到期时间">
              <span :class="['vip-expire', expireClass]">{{ formatDate(info.vip_expire_time) || '-' }}</span>
              <el-tag v-if="expireSoon" type="warning" size="mini" style="margin-left:8px">即将到期</el-tag>
            </el-descriptions-item>
          </el-descriptions>
          <el-button type="primary" size="mini" style="margin: 18px 0 8px 0;" @click="$router.push('/manageApiKey')">管理API Key</el-button>
          <!-- <div style="margin: 24px 0 8px 0; font-weight: bold;">API Key 列表</div>
          <el-table :data="info.api_keys || []" border stripe style="width: 100%" :fit="true">
            <el-table-column prop="api_key" label="API Key" min-width="260" />
            <el-table-column label="配额" width="100">
              <template slot-scope="scope">
                <el-tooltip content="配额不再限制总请求次数，仅作为参考值" placement="top">
                  <span>{{ scope.row.quota }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '禁用' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.create_time) }}
              </template>
            </el-table-column>
          </el-table> -->
          <div style="margin: 32px 0 8px 0; font-weight: bold;">卡密兑换</div>
          <el-form :inline="true" :model="redeemForm">
            <el-form-item label="卡密">
              <el-input v-model="redeemForm.card_code" placeholder="请输入卡密" style="width: 220px" @keyup.enter.native="onRedeem" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onRedeem" :loading="redeeming" native-type="button">兑换</el-button>
            </el-form-item>
          </el-form>
          <div v-if="lastRedeem" class="last-redeem">最近一次兑换：{{ lastRedeem.vip_type }}，到期：{{ formatDate(lastRedeem.vip_expire_time) }}</div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  data() {
    return {
      info: {},
      loading: false,
      error: '',
      redeemForm: {
        card_code: ''
      },
      redeeming: false,
      lastRedeem: null
    }
  },
  computed: {
    expireClass() {
      if (!this.info.vip_expire_time) return '';
      if (this.info.vip_type === 'forever') return 'forever';
      
      const now = new Date();
      // 检查是否是字符串"永久有效"
      if (this.info.vip_expire_time === '永久有效') return 'forever';
      
      const expire = new Date(this.info.vip_expire_time);
      if (expire < now) return 'expired';
      if ((expire - now) / (1000 * 60 * 60 * 24) < 7) return 'expiring';
      return 'active';
    },
    expireSoon() {
      if (!this.info.vip_expire_time) return false;
      if (this.info.vip_type === 'forever') return false;
      if (this.info.vip_expire_time === '永久有效') return false;
      
      const now = new Date();
      const expire = new Date(this.info.vip_expire_time);
      return expire > now && (expire - now) / (1000 * 60 * 60 * 24) < 7;
    }
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    vipTypeText(type) {
      const map = {
        week: '周卡',
        month: '月卡',
        quarter: '季卡',
        year: '年卡',
        forever: '永久卡'
      };
      return map[type] || type || '-';
    },
    async fetchInfo() {
      this.loading = true;
      this.error = '';
      try {
        const res = await this.$axios.get('/user/info', { headers: this.authHeader() });
        if (res && res.code === 200) {
          this.info = res.data || {};
          this.lastRedeem = res.data?.last_redeem || null;
        } else {
          this.error = res.message || '获取信息失败';
        }
      } catch (e) {
        this.error = e.response?.data?.message || '网络错误';
      } finally {
        this.loading = false;
      }
    },
    async onRedeem() {
      if (!this.redeemForm.card_code.trim()) {
        this.$message.warning('请输入卡密');
        return;
      }
      this.redeeming = true;
      try {
        const res = await this.$axios.post('/user/redeem', { card_code: this.redeemForm.card_code }, { headers: this.authHeader() });
        if (res && res.code === 200) {
          this.$message.success('兑换成功！VIP已更新');
          this.fetchInfo();
          this.redeemForm.card_code = '';
        } else {
          this.$message.error(res.message || '兑换失败');
        }
      } catch (e) {
        this.$message.error(e.response?.data?.message || '网络错误');
      } finally {
        this.redeeming = false;
      }
    },
    formatDate(val) {
      if (!val) return '';
      // 如果是永久有效，直接返回
      if (val === '永久有效') return val;
      
      try {
        const d = new Date(val);
        // 检查日期是否有效
        if (isNaN(d.getTime())) return val;
        
        const pad = n => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      } catch (e) {
        // 如果解析出错，直接返回原值
        return val;
      }
    },
    authHeader() {
      const token = localStorage.getItem('token');
      return token ? { Authorization: 'Bearer ' + token } : {};
    }
  }
}
</script>

<style scoped>
.user-info-container {
  max-width: 700px;
  margin: 32px auto;
}
.user-info-card {
  padding: 24px 24px 8px 24px;
}
.user-info-title {
  text-align: center;
  margin-bottom: 24px;
  font-weight: 500;
}
.vip-badge {
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  background: #67c23a;
}
.vip-badge.expiring {
  background: #e6a23c;
}
.vip-badge.expired {
  background: #909399;
}
.vip-badge.forever {
  background: #409eff;
}
.vip-expire.active {
  color: #67c23a;
}
.vip-expire.expiring {
  color: #e6a23c;
}
.vip-expire.expired {
  color: #909399;
}
.vip-expire.forever {
  color: #409eff;
  font-weight: bold;
}
.last-redeem {
  color: #888;
  margin: 8px 0 0 0;
  font-size: 14px;
}
.user-info-card ::v-deep .el-table__body-wrapper {
  border-bottom: none !important;
  box-shadow: none !important;
  background: none !important;
}
</style> 